/**
 * YouTube Video Player Component
 * Shows a poster image initially and loads the YouTube video when clicked
 */

if (!customElements.get('youtube-video-player')) {
  customElements.define('youtube-video-player', class YouTubeVideoPlayer extends HTMLElement {
    constructor() {
      super();

      this.videoId = this.getAttribute('data-video-id');
      this.poster = this.querySelector('.video-poster');
      this.playButton = this.querySelector('.video-play-button');
      this.iframeContainer = this.querySelector('.video-iframe-container');

      if (!this.videoId) {
        console.warn('YouTube video ID is missing');
        return;
      }

      this.init();
    }

    init() {
      // Add click event to poster and play button
      if (this.poster) {
        this.poster.addEventListener('click', this.playVideo.bind(this));
      }

      if (this.playButton) {
        this.playButton.addEventListener('click', this.playVideo.bind(this));
      }
    }

    playVideo(event) {
      event.preventDefault();

      if (!this.videoId) return;

      // Create YouTube iframe
      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', `https://www.youtube.com/embed/${this.videoId}?autoplay=1&rel=0`);
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', 'YouTube video player');

      // Clear iframe container and add iframe
      this.iframeContainer.innerHTML = '';
      this.iframeContainer.appendChild(iframe);

      // Show iframe container and hide poster
      this.iframeContainer.style.display = 'block';
      if (this.poster) {
        this.poster.style.display = 'none';
      }
    }
  });
}
